<template>
  <div class="banner" :class="`banner-${kind}`">
    <icon :kind="iconKind"></icon>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/togo/icon';

export default {
  name: "Banner",

  components: {
    Icon
  },

  props: {
    kind: {
      type: String,
      required: true,
      validator: function (value) {
        return ['warning', 'info'].indexOf(value) !== -1;
      }
    }
  },

  computed: {
    iconKind() {
      switch (this.kind) {
        case 'warning':
          return 'alert';
        case 'info':
          return 'info';
      }
    }
  }
}

</script>

<style lang="sass" scoped>
  @import "src/scss/variables"

  .banner
    width: 100%
    display: flex
    padding: 10px 26px
    text-align: left
    font-size: 13px

    i
      margin-right: 16px
      font-size: 24px

    div
      margin-top: 3px

    &.banner-info
      color: $white
      background-color: $info

    &.banner-warning
      color: $white
      background-color: $warning

</style>
